import React, { Component } from 'react';
import NextBestActionsRow from './NextBestActionsRow';

class NextBestActions extends Component {
    render() {
        const { actions } = this.props;
        return (
            <div>
                {actions ?.length > 0 ? actions.map(nextBestAction => {
                    return <NextBestActionsRow key={nextBestAction.id} data={nextBestAction} />;
                    })
                : <p>TODO No next best actions message</p>}
            </div>
        );
    }
}

export default NextBestActions;


// WEBPACK FOOTER //
// ./components/Agile/Components/NextBestActions.js